function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.47 45.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n        folder\n    ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation_bottom_tools",
    "data-name": "Navigation bottom tools"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "16.5 9.36 16.5 4.38 39.95 4.38 46.97 0.73 63.73 0.73 63.73 36.14",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#fff",
      strokeWidth: "1.47px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.41,44.73H14.94a1.32,1.32,0,0,1-1.2-.73L.79,15.49a.6.6,0,0,1,.59-.83H48.29a2.14,2.14,0,0,1,2,1.22L62.61,43.06A1.21,1.21,0,0,1,61.41,44.73Z",
    style: {
      strokeMiterlimit: 10,
      fill: "none",
      stroke: "#fff",
      strokeWidth: "1.47px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.2ee196a2.svg";
export { ForwardRef as ReactComponent };